import axios from "../../utils/axios";

async function fetchList(params) {
  return await axios.get("/dine-table", { params });
}

async function create(data) {
  return await axios.post("/dine-table", data);
}

async function addItemsToTable(data) {
  return await axios.patch("single/orders/dine-order/add-items", data);
}

async function removeItemFromTable(data) {
  return await axios.patch("single/orders/dine-order/remove-item", data);
}

// one line of an open table bill: new quantity (0 removes it)
async function updateItem(data) {
  return await axios.patch("single/orders/dine-order/update-item", data);
}

// move an open table bill to a free table
async function moveTable(data) {
  return await axios.patch("single/orders/dine-order/move-table", data);
}

// floor plan: halls, signs and table places of every floor
async function fetchFloorPlan() {
  return await axios.get("/dine-table/floor-plan");
}

// save one floor (owner / admin): { sections, labels, tables }
async function saveFloorPlan(floor, data) {
  return await axios.put(`/dine-table/floor-plan/${floor}`, data);
}

// delete a free table that no order points at
async function remove(id) {
  return await axios.delete(`/dine-table/${id}`);
}

export const tableService = {
  fetchList,
  create,
  fetchFloorPlan,
  saveFloorPlan,
  remove,
  addItemsToTable,
  removeItemFromTable,
  updateItem,
  moveTable,
};
